module.exports = __webpack_public_path__ + "static/media/Y-Ship-Cloud-Getting-Started-Rakuten.82994619.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/Y-Ship-Cloud-Getting-Started-Rakuten.pdf
// module id = 813
// module chunks = 0